
import React from 'react';
import Navbar from '@/components/Navbar';
import AdminSidebar from '@/components/admin/AdminSidebar';
import { useAuth } from '@/contexts/auth/AuthContext';
import { Navigate } from 'react-router-dom';
import { UserRoles } from '@/contexts/auth/enums';

interface AdminLayoutProps {
  children: React.ReactNode;
}

const AdminLayout: React.FC<AdminLayoutProps> = ({ children }) => {
  const { user, isAuthenticated, isLoading } = useAuth();

  // Helper function to check if user is admin
  const isAdmin = () => {
    if (!user) return false;
    return user.roles.includes(UserRoles.ADMIN);
  };

  // Show loading state while checking authentication
  if (isLoading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
      </div>
    );
  }

  // Check if user is authenticated and has admin role
  if (!isAuthenticated || !isAdmin()) {
    return <Navigate to="/" replace />;
  }

  return (
    <div className="flex h-screen overflow-hidden">
      <AdminSidebar />
      <div className="flex-1 overflow-y-auto bg-background">
        <Navbar variant="admin" className="sticky top-0" />
        <main className="mt-16">
          {children}
        </main>
      </div>
    </div>
  );
};

export default AdminLayout;
